module.exports = __webpack_public_path__ + "img/evenement.ca510767.png";